'usee strict';

import header from './header.js';

function createCookie (name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
}

function readCookie (name) {
    var nameEQ = encodeURIComponent(name) + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
}

function eraseCookie (name) {
    createCookie(name, '', -1);
}
class Geoblock {
    init () {
        this.lastCountryVisitedKey = 'lastVisited';
        if ($('.geoblockContainerBlur').length !== 0) {
            this.observeCloseButton();
            this.countryCheck();
        }
    }

    observeCloseButton () {
        var _self = this;
        $('.geoblock-close').on('click', function (e) {
            createCookie(_self.lastCountryVisitedKey, _self.getCurrentCountry());
            $('.geoblockContainerBlur').addClass('hidden');
            $('.navbar').css('margin-top', '-20px');
            header.updatePage();
        });
    }

    countryCheck () {
        var _self = this;
        let lastCountryVisited = readCookie(this.lastCountryVisitedKey);
        let currentCountry = _self.getCurrentCountry();
        let physicalCountry = _self.getPhysicalCountry();

        if (lastCountryVisited !== null) {
            if (lastCountryVisited !== currentCountry) {
                eraseCookie(_self.lastCountryVisitedKey);

                // Show new country
                if (currentCountry !== physicalCountry) {
                    $('.geoblockContainerBlur').removeClass('hidden');
                }
            } else {
                $('.geoblockContainerBlur').addClass('hidden');
                $('.navbar').css('margin-top', '-20px');   
            }
        }
    }

    getCurrentCountry () {
        return ($('.geoblockContainer').data('current-country') || '').toLowerCase();
    }

    getPhysicalCountry () {
        return ($('.geoblockContainer').data('physical-country') || '').toLowerCase();
    }
}

let geoblockHelper = new Geoblock();
module.exports = geoblockHelper;
